import styled, { withTheme } from 'styled-components'
import React, { useState, useRef } from 'react';
import useElementInertialParallax from '../../../../hooks/useElementInertialParallax';

const BackgroundContainer = styled.div`
    position:absolute;
    right: 0;
    left: 0;
    top: 0;
    z-index:0;
    width:100%;
    height:100%;
    overflow:hidden;
`

const MapPosition = styled.div`
    width: 100%;
    max-width: 900px;
    height: auto;
    position:absolute;
    right:0;
    z-index:0;
`;

const MapContainer = styled.div`
    position:relative;
    height: 100%;
    width: 100%;

    box-shadow: 161px 14px 119px -31px  ${props => props.color} inset;
    -webkit-box-shadow: 161px 14px 119px -31px  ${props => props.color} inset;
    -moz-box-shadow: 161px 14px 119px -31px  ${props => props.color} inset;
`;

const Map = styled.img`
    height:100%;
    width: 100%;
    opacity:.9;

    &::before {
        content: "";
        
        height: 100%;
        position: absolute;
        width: 100%;
    }
    
`;

const PinPosition = styled.div`   
    position: absolute; 
    width: 2px;
    height: 2px;
    overflow: visible;

    text-align:center;
    right:${props => props.pinPositionX}%;
    top:${props => props.pinPositionY}%;
    z-index:3;
`

const PinContainer = styled.div`   
    text-align:center;
    z-index:3;
    width: 216px;
    margin-left: -108px;
    margin-top: -200px;
    
    img {
        margin:0;
        max-width:216px;
    }

    p {
        padding:0;
        margin: -20% auto;
        color: #FFF;
        font-family: ${props => props.theme.fonts.display};
        font-weight:700;
        font-size:1em;
        text-transform: uppercase;
    }
`

const BackgroundGradient = styled.div`
        position:absolute;
        width:100%;
        height:100%;
        z-index:2;

        ${(props) => {
            if (props.vertical) {
                return ` 
                background: linear-gradient(90deg, ${props.bgColor} 55%, ${props.bgColor + 10} 65%);

                @media (max-width: ${props.theme.pageWidth.l}px) {
                    background: linear-gradient(90deg, ${props.bgColor} 10%, ${props.bgColor + 10} 50%);
                }

                @media (max-width: ${props.theme.pageWidth.s}px) {
                    display: none;
                }
            `;
            }
            return `
                background: linear-gradient(0deg, ${props.bgColor} 10%, ${props.bgColor + 10} 50%);

                @media (max-width: ${props.theme.pageWidth.l}px) {
                    background: linear-gradient(0deg, ${props.bgColor} 40%, ${props.bgColor + 10} 80%);
                }

                @media (max-width: ${props.theme.pageWidth.s}px) {
                    background: linear-gradient(0deg, ${props.bgColor} 45%, ${props.bgColor + 10} 60%);
                }
            `;

        }}
      
`;

const MapBackground = (props) => {
    const mapParallaxElement = useRef(null)
    const [ mapOffset, setMapOffset ] = useState(0)
    let mapImage = props.mapImage
    let pinImage = props.pinImage

    useElementInertialParallax((parallaxValue) => {
        setMapOffset(0 + parallaxValue * -20)
    }, mapParallaxElement)

    return (
        <BackgroundContainer
            cityName={props.cityName}>
            <MapPosition
                    bgPositionX={props.bgPositionX}
                    bgPositionY={props.bgPositionY}>
                <MapContainer color={props.bgColor} ref={mapParallaxElement} style={ { transform: `translate3d(0,${mapOffset}%,0)` } }>
                    <Map className="map"
                        src={require(`../../../../../assets/img/bg/${mapImage}.jpg`).default} 
                        alt={props.mapImgAlt}
                        />

                    <PinPosition
                        pinPositionX={props.pinPositionX}
                        pinPositionY={props.pinPositionY}>
                        <PinContainer>
                            <img className="pin" src={require(`../../../../../assets/img/bg/${pinImage}.png`).default} alt={props.pinImgAlt}></img>
                            <p>{props.cityName}</p>
                        </PinContainer>
                    </PinPosition>
                </MapContainer>
            </MapPosition>
            
            <BackgroundGradient vertical={false} bgColor={props.bgColor}></BackgroundGradient>
        </BackgroundContainer>
    );
};

export default withTheme(MapBackground);